import { render, staticRenderFns } from "./GPieChart.vue?vue&type=template&id=799e2018&"
import script from "./GPieChart.vue?vue&type=script&lang=js&"
export * from "./GPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports